import { render, staticRenderFns } from "./LearnMoreModal.vue?vue&type=template&id=30d8159b&scoped=true&"
import script from "./LearnMoreModal.vue?vue&type=script&lang=ts&"
export * from "./LearnMoreModal.vue?vue&type=script&lang=ts&"
import style0 from "./LearnMoreModal.vue?vue&type=style&index=0&id=30d8159b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d8159b",
  null
  
)

export default component.exports